export function recordImpression(
  tracking,
  { custId, page, tmpl, pgrp, item, link, srch, schnor, imrk }
) {
  if (tracking) {
    tracking.recordImpression(
      custId,
      page,
      tmpl,
      pgrp,
      item,
      link,
      srch,
      schnor,
      imrk
    );
  }
  return;
}

export function recordClick(
  tracking,
  { custId, page, tmpl, pgrp, item, link, srch, schnor, imrk }
) {
  if (tracking) {
    tracking.recordClick(
      custId,
      page,
      tmpl,
      pgrp,
      item,
      link,
      srch,
      schnor,
      imrk
    );
  }
  return;
}
